import { render, staticRenderFns } from "./WhyWeAreGood.vue?vue&type=template&id=c509a228&scoped=true&"
import script from "./WhyWeAreGood.vue?vue&type=script&lang=ts&"
export * from "./WhyWeAreGood.vue?vue&type=script&lang=ts&"
import style0 from "./WhyWeAreGood.vue?vue&type=style&index=0&id=c509a228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c509a228",
  null
  
)

export default component.exports